<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title class="d-flex align-items-end w-100 justify-content-between">
          Kasalar Raporu
          <b-card-sub-title
            class="font-medium-2 badge badge-light-success badge-pill px-1"
          >
            {{ moment(filterParams.edate).format('DD.MM.YYYY') }}
          </b-card-sub-title>
        </b-card-title>
      </b-card-header>
      <b-table-simple
        responsive
        striped
        bordered
        class="mb-0"
      >
        <b-thead>
          <b-tr>
            <b-th>
              Kasa
            </b-th>
            <b-th class="width-200 text-nowrap text-right">
              Zekat Bakiye
            </b-th>
            <b-th class="width-200 text-nowrap text-right">
              Sadaka Bakiye
            </b-th>
            <b-th class="width-200 text-nowrap text-right">
              Güncel Bakiye
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template
            v-for="(item,index) in safes.data"
          >
            <b-tr :key="index">
              <b-td>
                {{ item.title }}
              </b-td>
              <b-td class="text-right">
                {{ item.zekat_amount | toCurrency }} TL
              </b-td>
              <b-td class="text-right">
                {{ item.sadata_amount | toCurrency }} TL
              </b-td>
              <b-th class="text-right">
                {{ item.amount | toCurrency }} TL
              </b-th>
            </b-tr>
          </template>
        </b-tbody>
        <b-tfoot>
          <b-tr>
            <b-th>
              Genel Toplam
            </b-th>
            <b-th class="text-right">
              {{ safes.grandTotal.zekat_amount | toCurrency }} TL
            </b-th>
            <b-th class="text-right">
              {{ safes.grandTotal.sadata_amount | toCurrency }} TL
            </b-th>
            <b-th class="text-right">
              {{ safes.grandTotal.total_amount | toCurrency }} TL
            </b-th>
          </b-tr>
        </b-tfoot>
      </b-table-simple>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BTableSimple, BThead, BTbody, BTh, BTd, BTr, BTfoot, BCardHeader, BCardTitle, BCardSubTitle,
} from 'bootstrap-vue'

export default {
  name: 'SafesReport',
  components: {
    BCard,
    BTableSimple,
    BThead,
    BTbody,
    BTfoot,
    BTh,
    BTd,
    BTr,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
  },
  computed: {
    month() {
      return this.$store.getters['directorReports/month']
    },
    filterParams() {
      return this.$store.getters['directorReports/filterParams']
    },
    safes() {
      return this.$store.getters['directorReports/safes']
    },
  },
}
</script>
